//  Factory SSR-safe
import { createStore } from 'vuex'
import plpModule from '@/store/plp'
import pdpModule from '@/store/pdp'
import comunes from '@/store/comunes'

import neumaticos from '@/store/neumaticos'
import aceites from '@/store/aceites'
import baterias from '@/store/baterias'
import frenos from '@/store/frenos'
import afinamiento from '@/store/afinamiento'
import amortiguadores from '@/store/amortiguadores'
import trendelantero from '@/store/trendelantero'
import alineacion from '@/store/alineacion'
import balanceo from '@/store/balanceo'
import geometria from '@/store/geometria'
import kilometraje from '@/store/kilometraje'
import higienizacion from '@/store/higienizacion'
import fluidos from '@/store/fluidos'
import electrico from '@/store/electrico'
import accesorios from '@/store/accesorios'
import revisiontecnica from '@/store/revisiontecnica'
import form from '@/store/form'
import boletas from '@/store/boletas'
import carritoAbandonado from '@/store/carritoAbandonado'

export const createVuexStore = () => createStore({
  modules: {
    plpModule,
    pdpModule,
    comunes,

    // NEGOCIOS 
    neumaticos,
    aceites,
    baterias,
   
    frenos,
    afinamiento,
    amortiguadores,
    trendelantero,
    alineacion,
    balanceo,
    geometria,
    kilometraje,
    higienizacion,
    fluidos,
    electrico,
    accesorios,
    revisiontecnica,

    //advisor
    form,

    //boletas
    boletas,

    //carrito abandonado
    carritoAbandonado
  },
})